<template>
    <div>
        <Select :value="value2" placeholder="请选择" @on-select="hclick" id="treeselecter">
            <Tree id="maintree2" ref="tree1" :data="data5" :render="renderContent" style="height: 220px;overflow-y: auto;"></Tree>
        </Select>
    </div>
</template>
<script type="text/javascript">
// import store from '../../store'
export default {
    name: 'document_tree_child',
    components: {},
    props: {
        //raw:Array,
    },
    provide() {
        return {

        }
    },
    data() {
        return {
            value2: '',
            selectKey: 0,
            data5: [],
        }
    },
    methods: {
        show(data) {
            console.log('showtree==>')
            console.log(data)
            //JSON.parse(JSON.stringify(this.raw)),
            this.data5 = JSON.parse(JSON.stringify(data))
        },
        hclick(e) {
            // console.log('hclick==>')
            console.log(e)
            //设置选中
            if(e.label==='全部文件归档'){
                this.$emit('destination-folder', [])
                return
            }

            this.setTreeData(e)
            //popup data
            this.$emit('destination-folder', e)
        },
        // selectitem(value) {
        //     if (value.length > 0) {
        //         console.log(value)
        //         this.selectKey = value[0].nodeKey
        //     }

        // },
        //通过value查找
        recursionGet(setValues, valueId) {
            let value = null;
            for (let index = 0; index < setValues.length; index += 1) {
                if (setValues[index].value === valueId) {
                    setValues[index]._select = true
                    value = setValues[index];
                    //break;
                } else {
                    setValues[index]._select = false
                }
                if (setValues[index].children instanceof Array && setValues[index].children.length > 0) {
                    const text = this.recursionGet(setValues[index].children, valueId);
                }
            }
            //return value;
        },
        setTreeData(node) {
            let value = node.value
            console.log(value)
            let d = this.recursionGet(this.data5, value)
            //console.log(this.data5)
        },
        // renderContent(h, { root, node, data }) {
        //     return h('Option', {
        //         style: {
        //             display: 'inline-block',
        //             margin: '0'
        //         },
        //         props: {
        //             value: data.value
        //         },
        //         on: {
        //             click: (e) => {
        //                 console.log(node)
        //                 //this.setTreeData(node)

        //             }
        //         }
        //     }, data.title);
        // },
        renderContent(h, { root, node, data }) {
            //console.log(data.is_root)
            return h('Option', {
                style: {
                    display: 'inline-block',
                    cursor: "pointer",
                    backgroundColor: node.node._select ? "#D5E8FC" : "#fff",
                    borderRadius: '5px',
                    padding: '2px 4px',
                },
                props: {
                    value: data.value,
                },
                // on: {
                //     click: (e) => {
                //         this.setTreeData(node)

                //     }
                // }
            }, [
                h('span', [
                    h('Icon', {
                        props: {
                            type: 'md-folder',
                            color: '#ECC12B',
                            size: '16'
                        },
                        style: {
                            cursor: data.is_root ? 'not-allowed' : 'pointer'
                            //marginRight: '8px',
                        }
                    }),
                    h('span', {
                        style: {
                            cursor: data.is_root ? 'not-allowed' : 'pointer'
                        }
                    },data.title)
                ]),
                h('span', {
                    style: {
                        display: 'inline-block',
                        float: 'right',
                    }
                })
            ]);
        },
    }
}
</script>
<style lang="less" scoped>
#maintree2/deep/ .ivu-tree-title {
    //width: 90%;
    padding: 0;
    border-radius: 5px;
    vertical-align: middle;


}

#maintree2/deep/ ul li {
    margin: 0px 0;
    padding: 2px 0;
}
</style>